import { Component } from 'vue';
import store from '@/store';

export interface DropdownOptions {
  show: boolean;
  isLoading: boolean;
  component?: Component;
  data?: any;
  x?: number;
  y?: number;
}

const Dropdown = {
  install(Vue: any) {
    Vue.prototype.$dropdown = {
      show: (options: DropdownOptions) => {
        store.commit('setDropdownRoomStatus', options);
      },
      hide: () => store.commit('setDropdownRoomStatus', {show: false}),
      isShown: store.state.dashboard.dropdownRoomStatus.show,
    };
  },
};

export default Dropdown;
